export const messages = {
  en: {
    editItemReleaseView: {
      title: 'Edit Release',
      releaseType: 'Release Type',
      applyCompany: 'Apply Company',
      applyPerson: 'Applicant',
      idCard: 'ID Card',
      phone: 'Phone',
      passTime: 'Pass Time',
      carNum: 'Car Number',
      remark: 'Remark',
      releaseItems: 'Release Items',
      itemName: 'Item Name',
      itemAmount: 'Quantity',
      addItem: 'Add Item',
      selectReleaseType: 'Required, please select release type',
      inputApplyCompany: 'Required, please enter apply company',
      inputApplyPerson: 'Required, please enter applicant',
      inputIdCard: 'Required, please enter ID card',
      inputPhone: 'Required, please enter phone',
      selectPassTime: 'Required, please select pass time',
      inputCarNum: 'Optional, please enter car number',
      inputRemark: 'Optional, please enter remark',
      inputItemName: 'Required, please enter item name',
      inputItemAmount: 'Required, please enter quantity',
      page: {
        subtitle: 'Edit item release information and released items',
        emptyItems: 'No released items added yet'
      }
    }
  },
  zh: {
    editItemReleaseView: {
      title: '编辑放行',
      releaseType: '放行类型',
      applyCompany: '申请单位',
      applyPerson: '申请人',
      idCard: '身份证',
      phone: '手机号',
      passTime: '通行时间',
      carNum: '车牌号',
      remark: '备注',
      releaseItems: '放行物品',
      itemName: '物品名称',
      itemAmount: '物品数量',
      addItem: '添加物品',
      selectReleaseType: '必填，请选择放行类型',
      inputApplyCompany: '必填，请填写申请单位',
      inputApplyPerson: '必填，请填写申请人',
      inputIdCard: '必填，请填写身份证',
      inputPhone: '必填，请填写手机号',
      selectPassTime: '必填，请选择通行时间',
      inputCarNum: '选填，请填写车牌号',
      inputRemark: '选填，请填写备注',
      inputItemName: '必填，请填写物品名称',
      inputItemAmount: '必填，请填写数量',
      page: {
        subtitle: '修改物品放行信息与放行物品',
        emptyItems: '尚未添加放行物品'
      }
    }
  }
}